export default __webpack_public_path__ + "static/media/Tem_Prompt-Modal.c2929d20.png";